import { Snackbar, SnackbarProps } from '@mui/material';
import { Colors } from 'copyright-clearance-center-common-ui';
import React from 'react';

const WarningSnackBar: React.FunctionComponent<SnackbarProps> = props => {
	return (
		<Snackbar
			{...props}
			sx={{
				'.MuiSnackbarContent-root': {
					color: Colors.neutral900,
					border: `1px solid ${Colors.warning300}`,
					backgroundColor: Colors.warning100
				}
			}}
		/>
	);
};

export default WarningSnackBar;
